var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-tlv2-index" }, [
    _c("div", { staticClass: "header", on: { click: _vm.logout } }, [
      _c("div", { staticClass: "header-img" }, [
        _c("img", { attrs: { src: _vm.ossHost + "img/logo_min.png" } })
      ]),
      _c("div", { staticClass: "header-name" }, [_vm._v(_vm._s(_vm.name))]),
      _c("div", { staticClass: "header-btn" }, [_vm._v("退出登录")])
    ]),
    _c("div", { staticClass: "body" }, [
      _c(
        "div",
        { staticClass: "item", on: { click: _vm.onclickDeviceTestBtn } },
        [
          _c("img", { attrs: { src: _vm.ossHost + "img/icon_tofactory.png" } }),
          _c("div", { staticClass: "item-title" }, [_vm._v("设备测试")]),
          _vm._m(0)
        ]
      ),
      _c("div", { staticClass: "item", on: { click: _vm.onclickCheckBtn } }, [
        _c("img", { attrs: { src: _vm.ossHost + "img/icon_zhijian.png" } }),
        _c("div", { staticClass: "item-title" }, [_vm._v("出厂质检")]),
        _vm._m(1)
      ]),
      _c(
        "div",
        { staticClass: "item", on: { click: _vm.onclickCheckHistoryBtn } },
        [
          _c("img", { attrs: { src: _vm.ossHost + "img/icon_zhijian.png" } }),
          _c("div", { staticClass: "item-title" }, [_vm._v("质检记录")]),
          _c("div", { staticClass: "item-desc" }, [
            _vm._v("查询已质检的虾罾记录")
          ])
        ]
      ),
      _c(
        "div",
        { staticClass: "item", on: { click: _vm.onclickBarcodeBindBtn } },
        [
          _c("img", { attrs: { src: _vm.ossHost + "img/icon_outbound.png" } }),
          _c("div", { staticClass: "item-title" }, [_vm._v("关联条形码")]),
          _c("div", { staticClass: "item-desc" }, [
            _vm._v("出库时关联条形码和二维码")
          ])
        ]
      )
    ]),
    _c("div", { staticClass: "footer" }, [
      _c("img", { attrs: { src: _vm.ossHost + "img/logo.png" } })
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-desc" }, [
      _c("span", { staticClass: "bold" }, [_vm._v("生产部")]),
      _vm._v("进行设备功能测试")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-desc" }, [
      _c("span", { staticClass: "bold" }, [_vm._v("包装部")]),
      _vm._v("进行整机质检")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }